"use client";

import { useEffect } from "react";
import { ReactLenis, useLenis } from "lenis/react";
import { useReducedMotion } from "framer-motion";

/** Exposes the active Lenis instance on window so plain handlers can scrollTo. */
function ExposeLenis() {
  const lenis = useLenis();
  useEffect(() => {
    (window as unknown as { __lenis?: unknown }).__lenis = lenis ?? undefined;
  }, [lenis]);
  return null;
}

/**
 * Wraps the app in Lenis inertia/smooth scrolling — the buttery, weighted
 * scroll feel behind most award-winning sites. framer-motion's `useScroll`
 * keeps working because Lenis drives the real document scroll position.
 * Wheel smoothing is disabled under reduced-motion.
 */
export function SmoothScroll({ children }: { children: React.ReactNode }) {
  const reduce = useReducedMotion();
  return (
    <ReactLenis
      root
      options={{
        lerp: 0.09,
        smoothWheel: !reduce,
        wheelMultiplier: 1,
        touchMultiplier: 1.5,
        anchors: true,
      }}
    >
      <ExposeLenis />
      {children}
    </ReactLenis>
  );
}
